import * as yup from 'yup';

export const customerSchema = yup.object({
  phoneNumber: yup.string().required('Phone Number is required'),
  firstName: yup.string().required('First Name is required'),
  lastName: yup.string().required('Last Name is required'),
  email: yup.string().email('Invalid email format').required('Email is required'),
  idCardType: yup.string().notOneOf(['default'], 'ID Card Type is required'),
  idcardNumber: yup
    .string()
    .when('idCardType', {
      is: 'ID',
      then: yup.string().matches(/^([VE]-)?\d{6,9}$/, 'Formato inválido (ej: V-12345678 o 12345678)')
    })
    .when('idCardType', {
      is: 'Passport',
      then: yup.string().min(6, 'Mínimo 6 caracteres')
    })
    .when('idCardType', {
      is: 'Rif',
      then: yup.string().min(8, 'Mínimo 8 caracteres')
    })
    .when('idCardType', {
      is: 'DrivingLicense',
      then: yup.string().required('Driving License Number is required')
    })
    .required('ID Card Number is required'),
  address: yup.string().required('Address is required')
  //idFile: yup.mixed()
});
